import { render, staticRenderFns } from "./NavigatingButtons.vue?vue&type=template&id=5b3c48ab&scoped=true&"
import script from "./NavigatingButtons.vue?vue&type=script&lang=js&"
export * from "./NavigatingButtons.vue?vue&type=script&lang=js&"
import style0 from "./NavigatingButtons.vue?vue&type=style&index=0&id=5b3c48ab&prod&lang=css&"
import style1 from "./NavigatingButtons.vue?vue&type=style&index=1&id=5b3c48ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c48ab",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
